import React, { useState } from 'react';
import { HGTable } from 'components/HGTable';
import { upgradeHistoryColumns } from './upgradeHistoryColumns';
import { useGetIDsFromURL } from '../helper';
import { useUpgradeRecords } from './service';

const UpgradeHistory = () => {
    const { pathname } = useGetIDsFromURL();
    const { data: upgradeRecords, isLoading } = useUpgradeRecords();
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);

    return (
        <HGTable
            columns={upgradeHistoryColumns}
            data={upgradeRecords ?? []}
            rowsHref={(item) => `${pathname}/upgrade-history/${item.UpdateID}`}
            loading={isLoading}
            sortField={sortField}
            setSortField={setSortField}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            currentPage={1}
            setCurrentPage={() => {}}
            pageSize={upgradeRecords?.length ?? 0}
            totalItems={upgradeRecords?.length ?? 0}
        />
    );
};

export default UpgradeHistory;
